import { React, useEffect, useState } from "react";
import AxiosInstance from '../Axios'
import { Container, Grid, Typography, Box, Slide } from '@mui/material';
import Footer from '../Footer/Footer';
import Loading from '../Misc/Loading';
import OurTeam from "./OurTeam";

const About = () => {
  const [aboutData, setAboutData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = () => {
      AxiosInstance.get(`api/about`, {
        params: {
          isactive: 'true'
        }
      }).then((res) => {
        setAboutData(res.data);
      }).finally(() => {
        setLoading(false);
      });
    };

    getData();
  }, []);

  return (
    <>
      <section id="aboutus" className="standard-section" style={{ paddingTop: '56px' }}>
        {loading ?
          <Loading /> :
          <Container sx={{ py: { xs: 2, sm: 4 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                mx: 'auto',
                mb: { xs: 3, sm: 5 }
              }}
            >
              <Typography component="h2" variant="h4" className="standard-heading" sx={{ fontWeight: 700, color: '#0F172A', mb: 2 }}>
                About Us
              </Typography>
              <Typography 
                  variant="body1" 
                  className="standard-subheading" 
                  sx={{ 
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    lineHeight: 1.6,
                    letterSpacing: '0.01em',
                    color: '#475569',
                    fontSize: 'clamp(1.15rem, 1.2vw, 1.35rem)',
                  }}
                >
                Consider us as an integral part of your team, empowering you to confidently manage cloud security and compliance challenges. Our mission is clear: to deliver cloud security and compliance through automation, guaranteeing improved efficiency, accuracy, and regulatory adherence tailored to your specific needs.
              </Typography>
            </Box>
            <>
              {Array.isArray(aboutData) && aboutData.length > 0 ?
                aboutData.map((item, index) => (
                  <Grid
                    key={index}
                    container
                    spacing={2}
                    sx={{ pt: { xs: 2, sm: 4 } }}
                  >
                    <Grid item xs={12} md={6} order={{ sm: 2, md: index % 2 === 0 ? 2 : 1 }} sx={{ alignSelf: 'center' }}>
                      <Slide direction={index % 2 === 0 ? 'left' : 'right'} in={true} timeout={800}>
                        <Box
                          component="div"
                          sx={{
                            alignSelf: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img
                            src={`/assets/images/${item.image}`}
                            alt={item.title}
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </Box>
                      </Slide>
                    </Grid>
                    <Grid item xs={12} md={6} order={{ sm: 1, md: index % 2 === 0 ? 1 : 2 }} sx={{ alignSelf: 'center' }}>
                      <Box sx={{ height: 'fit-content', width: '100%', background: 'none' }}>
                        <Typography component="h3" variant="h5" className="standard-heading" sx={{ fontWeight: 700, color: '#0F172A', mb: 2 }}>
                          {item.title}
                        </Typography>
                        <Typography
                          component="p"
                          variant="body1"
                          className="standard-body"
                          sx={{ textAlign: 'justify' }}
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                ))
                : null
              }
            </>
          </Container>
        }
      </section>
      <section className="standard-section">
        <OurTeam />
      </section>
      <Footer />
    </>
  );
};

export default About;